<template>
    <div
        id="modal-container" 
        v-if="visible"
        class="modal-overlay"
        @click.self="handleOutsideClick"
    >

        <div class="modal-content">
            <table>
                <tbody>
                    <tr>
                        <td>Sergi adı (EN): </td>
                        <td>
                            <input type="text" v-model="dataCameFromAPI.exhibitionNameEN">
                        </td>
                    </tr>
                    <tr>
                        <td>Sergi adı (TR): </td>
                        <td>
                            <input type="text" v-model="dataCameFromAPI.exhibitionNameTR">
                        </td>
                    </tr>
                    <tr>
                        <td>Sergi metni (EN): </td>
                        <td>
                            <textarea name="exhibitionInfo_EN" id="exhibitionInfo_EN" cols="70" rows="20" v-model="dataCameFromAPI.exhibitionInfoEN">
                            </textarea>
                        </td>
                    </tr>
                    <tr>
                        <td>Sergi metni (TR): </td>
                        <td>
                            <textarea name="exhibitionInfo_TR" id="exhibitionInfo_TR" cols="70" rows="20" v-model="dataCameFromAPI.exhibitionInfoTR">
                            </textarea>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p>Sergi bilgileri değiştirilecektir. Bu işlem geri alınamaz.</p>
            <div class="modal-actions">
                <button @click="updateExhibitionInfo">Onayla</button>
                <button @click="cancel">İptal</button>
            </div>
        </div>
    
    </div>
</template>

<script>
import axios from 'axios';

export default{
    props:{
        visible: {
            type: Boolean,
            required: true
        },
        p_exhibitionInfo_EN:{
            type: String,
            required: true
        },
        p_exhibitionInfo_TR:{
            type: String,
            required: true
        },
        p_exhibitionName_EN:{
            type: String,
            required: true
        },
        p_exhibitionName_TR:{
            type: String,
            required: true
        }
    },

    emits: ["confirm", "cancel"],

    data() {
        return {
            dataCameFromAPI: {
                exhibitionInfoEN: "",
                exhibitionInfoTR: "",
                exhibitionNameEN: "",
                exhibitionNameTR: "",
            },
        };
    },

    methods:{
        async exhibitionInfoApiSave(){
            axios.put('/api-path/Exhibition/update-exhibition-info', this.dataCameFromAPI)
                .then(() => {
                    alert("Sergi bilgileri başarıyla güncellendi.");
                    })
                .catch(error => {
                    alert('Sergi bilgileri güncellenirken bir hata oluştu!\n'+ 'Hata: \n'+ error);
                    });
        },

        updateExhibitionInfo(){
            /*API update işlemi yapılacak*/
            this.exhibitionInfoApiSave();
            this.$emit("confirm", { ...this.dataCameFromAPI });
        },

        //Closing modals without clicking button
        handleKeyPress(event) {
            if (event.key === 'Escape') {
                this.$emit('cancel');
            }
        },
        handleOutsideClick() {
            this.$emit('cancel');
        },
        cancel(){
            this.$emit('cancel');
        }
    },

    mounted() {
        document.addEventListener('keydown', this.handleKeyPress);
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.handleKeyPress);
    },

    watch: {
        visible: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    // Modal açıldığında veriyi güncelle
                    this.dataCameFromAPI = {
                        exhibitionInfoEN: this.p_exhibitionInfo_EN,
                        exhibitionInfoTR: this.p_exhibitionInfo_TR,
                        exhibitionNameEN: this.p_exhibitionName_EN,
                        exhibitionNameTR: this.p_exhibitionName_TR,
                    };
                }
            },
        },
    },
}
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    width: 800px;
    height: 550px;
    overflow: auto;
    display: flex;
    flex-direction: column;
}

.modal-actions button {
    margin: 10px;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.modal-actions button:first-of-type {
    background: #17A2B8;
    color: aliceblue;
}

.modal-actions button:last-of-type {
    background: #DC3545;
    color: aliceblue;
}
table{
    width: 100%; /* Tablonun genişliği modal içerisine yayılsın */
    border-collapse: collapse;
}

td{
    padding: 10px; /* Hücre içeriğine boşluk ekler */
    text-align: left; /* İçeriği sola hizalar */
    font-weight: 800;
}
</style>